import { certificatesTypes, otherDocumentsTypes } from "../../../certificates/const/doc-types.const";
import { themeAtom } from "../../../shared/atoms";
import { requestQuestionnaireTypes } from "../../models/document-request.constants";
import DocTypesCheckboxes from "./DocTypesCheckboxes";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

const SelectDocumentsStep: React.FC = () => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className="flex flex-1 flex-col">
      <p className={twMerge("mb-6 text-2xl font-semibold", theme.uwhcAssistant.text)}>Select documents</p>
      <p className="mb-6">Choose the documents you would like to request.</p>

      <div
        className={twMerge(
          "flex flex-1 flex-row overflow-y-auto",
          "[&::-webkit-scrollbar]:w-1.5",
          "[&::-webkit-scrollbar-track]:bg-transparent",
          "[&::-webkit-scrollbar-thumb]:rounded-full",
          theme.uwhcAssistant.tableScroll,
          theme.uwhcAssistant.scrolHover,
        )}
      >
        <div className="flex-1 pl-[1px]">
          <p className="mb-4 text-[16px] font-bold">Certificates</p>
          <div className="flex flex-col gap-2 pb-8">
            <DocTypesCheckboxes docTypes={certificatesTypes} />
          </div>
        </div>

        <div className="flex-1">
          <p className="mb-4 text-[16px] font-bold">Questionnaires</p>
          <div className="flex flex-col gap-2">
            <DocTypesCheckboxes docTypes={requestQuestionnaireTypes} />
          </div>
          <p className="mb-4 mt-6 text-[16px] font-bold">Other documents</p>
          <div className="flex flex-col gap-2">
            <DocTypesCheckboxes docTypes={otherDocumentsTypes} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectDocumentsStep;
